import gql from "graphql-tag";

export async function loadSkills(apollo, skillJobType, profileId) {
  if (!skillJobType || !profileId) {
    return undefined;
  }

  let skillValueData = await apollo.query({
    query: gql`
      query($profile: ID!) {
        applicantProfileSkillValuesPage(profile: $profile, page: 1, size: 150) {
          results {
            skill {
              id
            }
            value
            active
          }
        }
      }
    `,
    variables: {
      profile: profileId
    }
  });

  let groupData = await apollo.query({
    query: gql`
      query($jobId: ID!) {
        applicantSkillGroups(jobType: $jobId, page: 1) {
          results {
            id
            name
            skillValues {
              id
              name
            }
          }
        }
      }
    `,
    variables: {
      jobId: skillJobType
    }
  });

  let result = [];
  for (let group of groupData.data.applicantSkillGroups.results) {
    group = JSON.parse(JSON.stringify(group)); // Remove observer

    let categoryData = await apollo.query({
      query: gql`
        query($groupId: ID!) {
          applicantSkillCategories(group: $groupId, page: 1) {
            results {
              id
              name
              skills {
                id
                name
                inputType
              }
            }
          }
        }
      `,
      variables: {
        groupId: group.id
      }
    });

    let categories = loadSkillCategoryValues(
      categoryData.data.applicantSkillCategories.results
    );

    if (categories.length) {
      result.push({
        group,
        categories
      });
    }
  }

  return result;

  function loadSkillCategoryValues(categories) {
    let result = [];
    for (const category of categories) {
      let catSkills = [];
      for (const skill of category.skills) {
        for (const value of skillValueData.data.applicantProfileSkillValuesPage
          .results) {
          if (value.skill.id === skill.id) {
            catSkills.push({
              ...skill,
              value: value.value
            });
          }
        }
      }

      if (catSkills.length) {
        result.push({
          ...category,
          skills: catSkills
        });
      }
    }

    return result;
  }
}
